import {
    IFieldsVisibleConfig,
    IFieldsVisibleConfigSet,
    IFieldsVisibleConfigSetRequest,
    IFieldsVisibleConfigSetResponse,
    IFieldsVisibleConfigWithRsRolesCopyRequest,
    IFieldsVisibleConfigWithRsRolesCopyResponse,
    IFieldsVisibleConfigWithRsRolesRequest,
    IFieldsVisibleWithRsConfigRequest,
    IFieldVisibleRsConfigSwitchRequest,
    IFieldVisibleRsConfigSwitchResponse,
    IIFieldsVisibleConfigReqeust,
} from 'CommonTypes/Forms/FormsFieldsConfig';
import { IFormsType } from 'CommonTypes/Forms/FormsTypes';
import {
    IAddRoleToFieldsVisibleRequest,
    IAddRoleToFieldsVisibleResponse,
    IDeleteRoleFromFieldVisibleResponse,
    IRolesVisibleFieldsRequest,
    IRolesVisibleFieldsSimpleSet,
} from 'CommonTypes/Forms/RolesVisibleFields';

import emptySplitApi from 'Endpoints/emptySplitApi';

import { IDeleteRoleFromFieldVisibleFrontRequest } from './types/IDeleteRoleFromFieldVisibleFrontRequest';

export const formsApi = emptySplitApi.injectEndpoints({
    endpoints: build => ({

        getFormsTypes: build.query<IFormsType[], void>({
            query: () => ({
                url: 'form/types',
            }),
        }),

        getFormsFieldsVisibleConfig: build.query<
            IFieldsVisibleConfigSet[],
            IIFieldsVisibleConfigReqeust
        >({
            query: params => ({
                url: 'form/fields/visible-config',
                params,
            }),
            transformResponse(respone: IFieldsVisibleConfig[]) {
                const result = respone.map(item => ({
                    id: item.id,
                    fieldId: item.fieldId,
                    name: item.name,
                    checked: Boolean(item.visible),
                }));

                return result;
            },
            providesTags: (result, error, { formTypeId, taskTypeId }) => [
                { type: 'FormsFieldsVisibleConfig', formTypeId, taskTypeId },
            ],
        }),

        getFormsFieldsVisibleConfigWithRsRoles: build.query<
            IFieldsVisibleConfigSet[],
            IFieldsVisibleConfigWithRsRolesRequest
        >({
            query: params => ({
                url: 'form/fields/visible-config-rs-roles',
                params,
            }),
            transformResponse(respone: IFieldsVisibleConfig[]) {
                const result = respone.map(item => ({
                    id: item.id,
                    fieldId: item.fieldId,
                    name: item.name,
                    checked: Boolean(item.visible),
                }));

                return result;
            },
            providesTags: (result, error, { taskId, formTypeId }) => [
                { type: 'GetFormsFieldsVisibleConfigWithRsRoles', taskId, formTypeId },
            ],
        }),

        getFormsFieldsVisibleWithRsConfig: build.query<
            IFieldsVisibleConfigSet[],
            IFieldsVisibleWithRsConfigRequest
        >({
            query: params => ({
                url: 'form/fields/visible-config-rs',
                params,
            }),
            transformResponse(respone: IFieldsVisibleConfig[]) {
                const result = respone.map(item => ({
                    id: item.id,
                    fieldId: item.fieldId,
                    name: item.name,
                    checked: Boolean(item.visible),
                }));

                return result;
            },
            providesTags: (result, error, { formTypeId, taskTypeId, rsId }) => [
                {
                    type: 'GetFormsFieldsVisibleWithRsConfig', formTypeId, taskTypeId, rsId,
                },
            ],
        }),

        setFormsFieldsVisibleConfig: build.mutation<
            IFieldsVisibleConfigSetResponse,
            IFieldsVisibleConfigSetRequest
        >({
            query: params => ({
                url: 'form/fields/visible-config',
                body: params,
                method: 'PATCH',
            }),
            invalidatesTags: (result, error, { formTypeId, taskTypeId }) => [
                { type: 'FormsFieldsVisibleConfig', formTypeId, taskTypeId },
                { type: 'TasksTypesSimpleSet', formTypeId },
            ],
        }),

        switchFormsFieldsVisibleWithRsconfig: build.mutation<
            IFieldVisibleRsConfigSwitchResponse,
            IFieldVisibleRsConfigSwitchRequest
        >({
            query: body => ({
                url: 'form/fields/visible-config-rs',
                body,
                method: 'POST',
            }),
            invalidatesTags: (result, error, { taskTypeId, rsId, fieldId }) => [
                {
                    type: 'GetFormsFieldsVisibleWithRsConfig', taskTypeId, rsId, fieldId,
                },
            ],
        }),

        getRolesVisibleFields: build.query<
            IRolesVisibleFieldsSimpleSet[],
            IRolesVisibleFieldsRequest
        >({
            query: params => ({
                url: 'form/roles-visible',
                params,
            }),
            providesTags: (result, error, { tasksTypeId, rsId, fieldId }) => [
                {
                    type: 'GetRolesVisibleFields', fieldId, rsId, tasksTypeId,
                },
            ],
        }),

        addRoleToVisibleFields: build.mutation<
            IAddRoleToFieldsVisibleResponse,
            IAddRoleToFieldsVisibleRequest
        >({
            query: body => ({
                url: 'form/roles-visible',
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, { tasksTypeId, rsId, fieldId }) => [
                {
                    type: 'GetRolesVisibleFields', fieldId, rsId, tasksTypeId,
                },
            ],
        }),

        deleteRoleFromVisibleFields: build.mutation<
            IDeleteRoleFromFieldVisibleResponse,
            IDeleteRoleFromFieldVisibleFrontRequest
        >({
            query: params => ({
                url: 'form/roles-visible',
                method: 'DELETE',
                params,
            }),
            invalidatesTags: (result, error, { fieldId, rsId, tasksTypeId }) => [
                {
                    type: 'GetRolesVisibleFields', fieldId, rsId, tasksTypeId,
                },
            ],
        }),

        copyFieldsVisibleConfigRsRoles: build.mutation<
            IFieldsVisibleConfigWithRsRolesCopyResponse,
            IFieldsVisibleConfigWithRsRolesCopyRequest
        >({
            query: body => ({
                url: 'form/fields/visible-config-rs-roles',
                method: 'PATCH',
                body,
            }),
            invalidatesTags: (result, error, { fieldIdTo, rsId, taskTypeId }) => [
                {
                    type: 'GetRolesVisibleFields', fieldId: fieldIdTo, rsId, tasksTypeId: taskTypeId,
                },
            ],
        }),

    }),
});

export const {
    useGetFormsTypesQuery,
    useGetFormsFieldsVisibleConfigQuery,
    useGetFormsFieldsVisibleWithRsConfigQuery,
    useGetFormsFieldsVisibleConfigWithRsRolesQuery,
    useSetFormsFieldsVisibleConfigMutation,
    useSwitchFormsFieldsVisibleWithRsconfigMutation,
    useGetRolesVisibleFieldsQuery,
    useAddRoleToVisibleFieldsMutation,
    useDeleteRoleFromVisibleFieldsMutation,
    useCopyFieldsVisibleConfigRsRolesMutation,
} = formsApi;
